import { NavLink, useLocation } from "react-router-dom"
import {
  Home,
  Trophy,
  Users,
  Calendar,
  Target,
  User,
  Settings,
  HelpCircle,
  Ticket,
} from "lucide-react"

import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

const items = [
  { title: "Home", url: "/", icon: Home },
  { title: "Leagues", url: "/leagues", icon: Trophy },
  { title: "Team", url: "/team", icon: Target },
  { title: "Matches", url: "/matches", icon: Calendar },
  { title: "Rewards", url: "/rewards", icon: Trophy },
  { title: "Buy Field Pass", url: "/buy-field-pass", icon: Ticket },
  { title: "Profile", url: "/profile", icon: User },
]

export function AppSidebar() {
  const { state } = useSidebar()
  const location = useLocation()
  const currentPath = location.pathname
  const isCollapsed = state === "collapsed"

  const isActive = (path: string) => currentPath === path

  const getNavCls = (path: string) =>
    isActive(path) 
      ? "bg-sidebar-primary text-sidebar-primary-foreground font-medium" 
      : "text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"

  return (
    <Sidebar className="border-r-0" collapsible="icon">
      <SidebarContent style={{ backgroundColor: '#1A1A1B' }}>
        {/* Logo Header */}
        <SidebarHeader className={`${isCollapsed ? 'px-2' : 'px-4'} py-6 border-b border-white/10`}>
          <div className="flex items-center justify-center">
            {!isCollapsed ? (
              // Full logo when expanded
              <div className="flex items-center gap-2">
                <img 
                  src="/lovable-uploads/04e827a2-62f6-402c-9f42-2bd01d8e3626.png" 
                  alt="Draftactics" 
                  className="h-8 w-8 object-contain"
                />
                <span className="text-white font-bold text-xl">Draftactics</span>
              </div>
            ) : (
              // Just icon when collapsed
              <img 
                src="/lovable-uploads/04e827a2-62f6-402c-9f42-2bd01d8e3626.png" 
                alt="Draftactics" 
                className="h-9 w-9 object-contain"
              />
            )}
          </div>
        </SidebarHeader>

        <SidebarGroup className="py-6">
          <SidebarGroupContent>
            <SidebarMenu className="space-y-2">
              <TooltipProvider>
                {items.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild className="h-12">
                      {isCollapsed ? (
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <NavLink 
                              to={item.url} 
                              className={`${getNavCls(item.url)} flex items-center justify-center w-full px-3 py-3 rounded-lg transition-all duration-200`}
                            >
                              <item.icon className="h-5 w-5 shrink-0" />
                            </NavLink>
                          </TooltipTrigger>
                          <TooltipContent side="right" className="ml-2">
                            <p>{item.title}</p>
                          </TooltipContent>
                        </Tooltip>
                      ) : (
                        <NavLink 
                          to={item.url} 
                          className={`${getNavCls(item.url)} flex items-center gap-3 px-4 rounded-lg transition-all duration-200`}
                        >
                          <item.icon className="h-5 w-5 shrink-0" />
                          <span className="text-sm font-medium">{item.title}</span>
                        </NavLink>
                      )}
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </TooltipProvider>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}